import SouthEastIcon from '@mui/icons-material/SouthEast';

export const digitalTypes = [
    {id: Math.random(), type: "SMM", arrow: <SouthEastIcon/>},
    {id: Math.random(), type: "SEO", arrow: <SouthEastIcon/>},
    {id: Math.random(), type: "Influencer Marketing", arrow: <SouthEastIcon/>},
    {id: Math.random(), type: "Email Marketing", arrow: <SouthEastIcon/>},
    {id: Math.random(), type: "PPC", arrow: <SouthEastIcon/>},
    {id: Math.random(), type: "Google Ads", arrow: <SouthEastIcon/>}
]